<template>
    <CoverImage :src="campaign.image_url" class="CampaignImage h-full b-rad-lg">
        <div class="PlatformIcon__wrapper absolute pos-b-l m-sm">
            <PlatformIcon :platform="campaign.platform"></PlatformIcon>
        </div>
    </CoverImage>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.CampaignImage {
    @media (max-width: @screen-xs-max) {
        padding-top: 60%;
    }
    @media (min-width: @screen-sm-min) {
        padding-top: 80%;
    }

    .PlatformIcon__wrapper {
        background-color: #fff;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        padding: 9px;
        text-align: center;
        border: 1px solid #d6e2eb;
    }

    .PlatformIcon {
        font-size: 40px;
    }
}
</style>

<script type="text/babel">
import CoverImage from 'dashboard-js/components/utilities/CoverImage'
import PlatformIcon from 'dashboard-js/components/platforms/PlatformIcon'
export default {
    components: { PlatformIcon, CoverImage },
    props: ['campaign'],
}
</script>
